import PropTypes from 'prop-types';

import OnboardedLocation from '../OnboardedLocation';
import UnboardedLocation from '../UnboardedLocation';
import isLocationActive from '../isLocationActive';

import './index.less';

export default function Locations({ locations, activeLocation, setActiveLocation, title, unboarded }) {
  return (
    <div className="locations" data-testid={`${unboarded ? 'unboarded' : 'onboarded'}-locations`}>
      <div className="locations--title">{title}</div>
      <div className="locations-section" data-testid="locations-list">
        {locations.map((location) =>
          !unboarded ? (
            <OnboardedLocation
              key={location.locationId}
              location={location}
              activeLocation={activeLocation}
              setActiveLocation={setActiveLocation}
              disabled={!isLocationActive(location)}
            />
          ) : (
            <UnboardedLocation
              key={location.locationId}
              location={location}
              activeLocation={activeLocation}
              setActiveLocation={setActiveLocation}
              disabled={!isLocationActive(location)}
            />
          ),
        )}
      </div>
    </div>
  );
}

Locations.propTypes = {
  locations: PropTypes.array.isRequired,
  activeLocation: PropTypes.object,
  setActiveLocation: PropTypes.func.isRequired,
  title: PropTypes.string,
  unboarded: PropTypes.bool,
};

Locations.defaultProps = {
  unboarded: false,
  title: 'Select your location',
};
